import { EyeIcon, NoSymbolIcon, PencilIcon } from "@/icons/outline";
import { MicrophoneIcon } from "@/icons/solid";
import { CrownIcon } from "@/components/common/icons/Solid";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../../store/actions/permissionActions";
import { permissionOptions } from "../PermissionOptions";

const iconNames = {
	Read: <EyeIcon style={{ height: "1.5em", float: "left" }} />,
	Write: <PencilIcon style={{ height: "1.5em", float: "left" }} />,
	None: <NoSymbolIcon style={{ height: "1.5em", float: "left" }} />,
};

const style = {
	containerBox: {
		display: "flex",
		height: "54.1px",
		flexWrap: "nowrap",
		overflow: "visible",
		width: 200,
	},
	firstBorder: {
		borderTop: "solid 1px #dee2e6",
		// borderRadius: "10px 0 0 0",
	},
	title: {
		background: "#fff",
		height: "54.1px",
		lineHeight: "54.1px",
		minWidth: "150px",
		padding: "0 15px",
		borderLeft: "solid 1px #dee2e6",
		borderRight: "solid 1px #dee2e6",
		borderBottom: "solid 1px #dee2e6",
	},
	extra: {
		background: "#fff",
		height: "54.1px",
		lineHeight: "54.1px",
		minWidth: "100px",
		padding: "0 15px",
		borderLeft: "solid 1px #dee2e6",
		borderRight: "solid 1px #dee2e6",
		borderBottom: "solid 1px #dee2e6",
		display: "flex",
	},
	borderBoxStyle: {
		minWidth: "54.1px",
		borderBottom: "solid 1px #dee2e6",
		borderRight: "solid 1px #dee2e6",
		width: "54.1px",
		height: "54.1px",
		background: "#fff",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
};

const PermissionsRow = ({
	user,
	index,
	savePermissions,
	updatePermission,
	jurisdiction,
	chosenPoC,
	isSameUser,
	disabled,
}) => {
	const { name, status, pointOfContact, permissions, dirty, saving, saved } = user;

	const isOwner = status === "Owner";

	return (
		<div style={style.containerBox}>
			<div
				style={{
					...style.title,
					borderTop: index == 0 ? "solid 1px #dee2e6" : "none",
					display: "flex",
					alignItems: "center",
					justifyContent: "flex-start",
					overflow: "hidden",
					whiteSpace: "nowrap",
					width: "20rem",
					minWidth: "20rem",
					textOverflow: "ellipsis",
				}}
			>
				{isOwner ? (
					<CrownIcon
						style={{
							height: "3rem",
							width: "3rem",
							minWidth: "3rem",
							color: "rgb(234,97,28)",
							marginRight: 5,
							boxShadow: "rgba(0,0,0,0.25) 2px 2px 2px",
							padding: "0.5rem",
							borderRadius: "50%",
						}}
					/>
				) : null}
				{pointOfContact || (!chosenPoC && isOwner) ? (
					<MicrophoneIcon
						style={{
							height: "3rem",
							width: "3rem",
							minWidth: "3rem",
							color: "rgb(234,97,28)",
							marginRight: 5,
							boxShadow: "rgba(0,0,0,0.25) 2px 2px 2px",
							padding: "0.5rem",
							borderRadius: "50%",
						}}
					/>
				) : null}
				{name}
				{isSameUser ? " (You)" : ""}
			</div>
			{permissionOptions.map((permission) => {
				if (permission?.exclude?.includes(jurisdiction)) return;

				const currentPermission = permissions?.[permission.name] || "Write";
				const iconName = iconNames[currentPermission];

				return (
					<div
						className="disable-select"
						title={currentPermission}
						style={{ ...style.borderBoxStyle, borderTop: index == 0 ? "solid 1px #dee2e6" : "none" }}
						key={permission.name}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							if (disabled) return;

							const currentPermissionIndex = permission.options.findIndex((o) => o == currentPermission);

							const nextPermissionIndex =
								currentPermissionIndex == permission.options.length - 1
									? 0
									: currentPermissionIndex + 1;

							updatePermission({
								user: user.id,
								permission: permission.name,
								value: permission.options[nextPermissionIndex],
							});
						}}
					>
						{iconName}
					</div>
				);
			})}
			<div style={{ ...style.extra, borderTop: index == 0 ? "solid 1px #dee2e6" : "none" }}>
				{saving && (
					<div
						className="btn btn-success"
						style={{ alignSelf: "center" }}
					>
						Saving
					</div>
				)}
				{saved && !dirty && <div style={{ alignSelf: "center" }}>Updated</div>}
				{dirty && !saving && (
					<div
						className="btn btn-success"
						style={{ alignSelf: "center" }}
						onClick={() => {
							savePermissions({
								userId: user.id,
								permissions: user.permissions,
							});
						}}
					>
						Save
					</div>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const isSameUser = state.my?.profile?.id === ownProps.user?.id;
	const pointOfContact = state.permissions?.authorisedUsers?.find((user) => user?.pointOfContact);

	return {
		isSameUser,
		chosenPoC: pointOfContact,
		jurisdiction: state.company?.settings?.jurisdiction,
		disabled:
			state?.permissions?.my?.permissions?.permissions == "Read" ||
			state?.company?.settings?.status == "Archived",
	};
};

const mapDispatchToProps = (dispatch) => ({
	// inviteUserModal: () => dispatch(ACTIONS.inviteUserModal()),
	// inviteUser: () => dispatch(ACTIONS.inviteUser()),
	updatePermission: (params) => dispatch(ACTIONS.updatePermission(params)),
	savePermissions: (params) => dispatch(ACTIONS.savePermissions(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsRow);
